import { useEffect } from "react";

type UseExpandedImageKeyboardParams = {
  visible: boolean;
  isWeb: boolean;
  onClose: () => void;
  onNext: () => void;
  onPrev: () => void;
};

export const useExpandedImageKeyboard = ({
  visible,
  isWeb,
  onClose,
  onNext,
  onPrev,
}: UseExpandedImageKeyboardParams) => {
  useEffect(() => {
    if (!visible || !isWeb) return;

    const handler = (event: KeyboardEvent) => {
      if (event.key === "Escape") {
        event.preventDefault();
        onClose();
      } else if (event.key === "ArrowRight") {
        event.preventDefault();
        onNext();
      } else if (event.key === "ArrowLeft") {
        event.preventDefault();
        onPrev();
      }
    };

    window.addEventListener("keydown", handler);
    return () => window.removeEventListener("keydown", handler);
  }, [visible, isWeb, onClose, onNext, onPrev]);
};
